import React from 'react';
import type { SVGProps } from 'react';

export function RadixIconsCornerBottomLeft(props: SVGProps<SVGSVGElement>) {
	return (<svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 15 15" {...props}><path fill="currentColor" d="M11.5 12a.5.5 0 0 0 0-1H9.9c-1.128 0-1.945 0-2.587-.053c-.636-.052-1.056-.153-1.402-.329a3.5 3.5 0 0 1-1.53-1.53c-.175-.345-.276-.765-.328-1.401C4 7.045 4 6.228 4 5.1V3.5a.5.5 0 0 0-1 0v1.6c0 1.111 0 1.976.057 2.668c.057.697.173 1.265.433 1.775a4.5 4.5 0 0 0 1.967 1.967c.51.26 1.078.376 1.775.433C7.924 12 8.79 12 9.9 12z"></path></svg>);
}

